"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickMonitoring = exports.publishComponentClickEvent = exports.MetricEvent = void 0;
const react_1 = require("react");
const katal_metrics_1 = require("./katal_metrics");
// Events can be XOR'ed together
var MetricEvent;
(function (MetricEvent) {
    MetricEvent[MetricEvent["None"] = 0] = "None";
    MetricEvent[MetricEvent["Click"] = 1] = "Click";
})(MetricEvent = exports.MetricEvent || (exports.MetricEvent = {}));
exports.publishComponentClickEvent = (dataId) => {
    katal_metrics_1.getMetricsPublisherChainAsync('click').then((p) => p
        //prettier-break
        .publishCounter(dataId, 1)
        .publishString('id', dataId));
};
exports.useClickMonitoring = () => {
    react_1.useEffect(() => {
        const clickEventCapture = (e) => {
            var _a;
            if (e.target) {
                const target = e.target;
                const dataId = target.getAttribute('data-id');
                if (MetricEvent.Click & parseInt((_a = target.getAttribute('data-publish-metrics')) !== null && _a !== void 0 ? _a : '0') && dataId) {
                    exports.publishComponentClickEvent(dataId);
                }
            }
        };
        window.addEventListener('click', clickEventCapture, false);
        return () => {
            window.removeEventListener('click', clickEventCapture);
        };
    });
};
